// extracted by mini-css-extract-plugin
export default {"card-img-top":"project_card-img-top__sTLGm","body":"project_body__RK0NS","projectHolder":"project_projectHolder__QPweQ"};